import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  Buttons_Styles,
  Card_Styles,
  Cards_Types,
  Choices_Styles,
  DropDown_Styles,
  Field_Text_Styles,
  MENU_BUTTON_FORM,
  c1,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";

@Component({
  selector: "app-button-picker-component",
  templateUrl: "./button-picker-component.component.html",
  styleUrls: ["./button-picker-component.component.scss"],
})
export class ButtonPickerComponentComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private datePipe: DatePipe
  ) {}

  @Input() button_id: string;
  @Input() config: any;
  mode: string;

  // default values
  icon: string;
  offCanvasSubscription: any;
  offcanvasColors = offcanvasColors;
  button: MenuButton;
  data: any;
  currentMenuSubscription: any;
  valueChangesSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  isAndroid: boolean;
  text_id: any;
  buttonFormTypes: typeof MENU_BUTTON_FORM = MENU_BUTTON_FORM;
  datepickerForm: UntypedFormGroup;

  stylesChoices = [];
  card_types = [];
  sync = true;
  updateForm = false;

  layouts = [
    {
      title: "date picker",
      image: "https://nandbox.com/wp-content/uploads/2025/05/Modal-date-picker.webp",
      key: "01",
    },
    {
      title: "docked",
      image: "https://nandbox.com/wp-content/uploads/2025/05/Modal-date-picker.webp",
      key: "02",
    },
    {
      title: "middle  popup",
      image: "https://nandbox.com/wp-content/uploads/2025/05/Modal-date-Input.webp",
      key: "03",
    },
  ];
  layoutsIOS = [
    {
      title: "inline",
      image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Inline-Expanded.webp",
      key: "01",
    },
    {
      title: "Popup",
      image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-Compact-Expanded.webp",
      key: "02",
    },
    {
      title: "middle  popup",
      image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Inline-Expanded_2.webp",
      key: "03",
    },
  ];

  list = [];


  ngOnInit() {
    this.field_id = "label";
    this.datepickerForm = this.formBuilder.group({
      format: new UntypedFormControl(""),
      min_date: new UntypedFormControl(""),
      max_date: new UntypedFormControl(""),
      style: new UntypedFormControl("01"),
      label: new UntypedFormControl(""),
    });
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      }
    );
  }

  buttonIntialize(data) {
    this.data = data.data;
    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.card_types = Cards_Types;
      if (!this.updateForm) {
        const min = this.parseAndFormatDate(this.button.button_picker.min_date, this.button.button_picker.format, 'yyyy-MM-dd');
        const max = this.parseAndFormatDate(this.button.button_picker.max_date, this.button.button_picker.format, 'yyyy-MM-dd');
        this.datepickerForm = this.formBuilder.group({
          format: new UntypedFormControl(
            (this.button.button_picker && this.button.button_picker.format) ||
              ""
          ),
          min_date: new UntypedFormControl(min ? new Date(min) : ""),
          max_date: new UntypedFormControl(max ? new Date(max) : ""),
          style: new UntypedFormControl(
            (this.isAndroid && this.button.button_picker && this.button.button_picker.style) ? this.button.button_picker.style : (!this.isAndroid && this.button.button_picker && this.button.button_picker.style_ios) ? this.button.button_picker.style_ios : "01"
          ),
          label: new UntypedFormControl(
            (this.button.button_picker && this.button.button_picker.label) || ""
          ),
        });
        this.updateForm = true;
      }

      switch (this.button.button_form) {
        case this.buttonFormTypes.DATEPICKER:
          this.layouts = [
            {
              title: "Picker",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Modal-date-picker_L.webp",
              key: "01",
            },
                {
              title: "Input",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Modal-date-Input_L.webp",
              key: "02",
            },
            {
              title: "Docked",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-Compact_L.webp",
              key: "03",
            },

          ];
          this.layoutsIOS = [
            {
              title: "Inline",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Inline-Expanded_L.webp",
              key: "01",
            },
            {
              title: "Wheels",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-Inline-Wheels_L.webp",
              key: "02",
            },
            {
              title: "Popup",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-Compact-Expanded_L.webp",
              key: "03",
            },
          ];
          break;
        case this.buttonFormTypes.DATERANGEPICKER:
          this.layouts = [
            {
              title: "Picker",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Full-screen-date-picke_range_L.webp",
              key: "01",
            },
            {
              title: "Input",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-range-input_L.webp",
              key: "02",
            },
            {
              title: "Compact",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-range-02_L-1.webp",
              key: "03",
            },
          ];
          this.layoutsIOS = [
            {
              title: "Inline",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Inline-Expanded_L.webp",
              key: "01",
            },
            {
              title: "Wheels",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-Inline-Wheels_L.webp",
              key: "02",
            },
            {
              title: "Popup",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Date-Picker-Compact-Expanded_L.webp",
              key: "03",
            },
          ];
          break;
        case this.buttonFormTypes.TIMEPICKER:
          this.layouts = [
            {
              title: "Picker",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Time-picker-dial_M.webp",
              key: "01",
            },
            {
              title: "Input",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Time-picker-input_M.webp",
              key: "02",
            },
          ];
          this.layoutsIOS = [
            {
              title: "Inline",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Time-Picker-Compact-Wheels_M.webp",
              key: "01",
            },
            {
              title: "Compact",
              image: "https://nandbox.com/wp-content/uploads/2025/05/Time-Picker-Inline-Wheels_M.webp ",
              key: "02",
            },
          ];
          break;
      }

      this.list = this.isAndroid ? this.layouts : this.layoutsIOS;
    }
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }



    parseAndFormatDate(dateString: string, inputFormat: string, outputFormat: string = 'yyyy-MM-dd'): string | null {
      if (!dateString || !inputFormat) {
        return null; // Return null if input is invalid
      }

      // Split the input format and date string into parts
      const formatParts = inputFormat.split(/[-/]/);
      const dateParts = dateString.split(/[-/]/);

      if (formatParts.length !== dateParts.length) {
        return null; // Return null if the format doesn't match the date string
      }

      // Map the date parts to day, month, and year
      const dateMap: { [key: string]: string } = {};
      formatParts.forEach((part, index) => {
        dateMap[part] = dateParts[index];
      });

      // Extract day, month, and year
      const day = dateMap['dd'] || dateMap['d'];
      const month = dateMap['MM'] || dateMap['M'];
      const year = dateMap['yyyy'] || dateMap['yy'];

      if (!day || !month || !year) {
        return null; // Return null if any part is missing
      }

      // Convert to a valid date object
      const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
      if (isNaN(parsedDate.getTime())) {
        return null; // Return null if the date is invalid
      }

      // Format the date to the desired output format
      return this.datePipe.transform(parsedDate, outputFormat);
    }


  onChange() {
    const selectedFormat = this.datepickerForm.get("format").value;
    if(this.button?.button_form === this.buttonFormTypes.DATEPICKER && this.button.button_value && this.button.button_value.length > 0 && this.button.button_value[0].value && selectedFormat){
      const parsedDate = this.parseAndFormatDate(this.button.button_value[0].value, this.button.button_picker["format"], "yyyy-MM-dd");
      this.button.button_value[0].value = this.datePipe?.transform(parsedDate, selectedFormat)
    }
    if(this.button?.button_form === this.buttonFormTypes.TIMEPICKER && this.button.button_value && this.button.button_value.length > 0 && this.button.button_value[0].value && selectedFormat){
      const parsedDate = this.updateTimeFromString(this.button.button_value[0].value);
      this.button.button_value[0].value = this.datePipe?.transform(parsedDate, selectedFormat)
    }
    if(this.button?.button_form === this.buttonFormTypes.DATERANGEPICKER && this.button.button_value && this.button.button_value.length > 0 && this.button.button_value[0].value && this.button.button_value[0].value.start && selectedFormat){
      const parsedDate = this.parseAndFormatDate(this.button.button_value[0].value.start, this.button.button_picker["format"], "yyyy-MM-dd");
      this.button.button_value[0].value.start = this.datePipe?.transform(parsedDate, selectedFormat)
    }
    if(this.button?.button_form === this.buttonFormTypes.DATERANGEPICKER && this.button.button_value && this.button.button_value.length > 0 && this.button.button_value[0].value && this.button.button_value[0].value.end && selectedFormat){
      const parsedDate = this.parseAndFormatDate(this.button.button_value[0].value.end, this.button.button_picker["format"], "yyyy-MM-dd");
      this.button.button_value[0].value.end = this.datePipe?.transform(parsedDate, selectedFormat)
    }
    this.button.button_picker["format"] = selectedFormat;
    if(this.isAndroid || this.sync){
      this.button.button_picker["style"] = this.datepickerForm.get("style")?.value;
      this.button.button_picker["label"] = this.datepickerForm.get("label")?.value;
    }
    if(!this.isAndroid || this.sync){
      this.button.button_picker["style_ios"] = this.datepickerForm.get("style")?.value;
      this.button.button_picker["label_ios"] = this.datepickerForm.get("label")?.value;
    }
    if (this.button &&(this.button?.button_form === this.buttonFormTypes.DATEPICKER ||this.button?.button_form === this.buttonFormTypes.DATERANGEPICKER)
    ) {
        this.button.button_picker["min_date"] = this.datePipe.transform(
        this.datepickerForm.get("min_date")?.value,    selectedFormat    );
      this.button.button_picker["max_date"] = this.datePipe.transform(
        this.datepickerForm.get("max_date")?.value,
        selectedFormat
      );
    }

    this.updateButtonData();
  }

  onChangeDate(event, key) {
    // this.datepickerForm.get(key).setValue(event);
    const selectedFormat = this.datepickerForm.get("format").value;
    let formattedMinDate = "";

    if (event) {
      formattedMinDate = this.datePipe.transform(event, selectedFormat);
    }

    this.button.button_picker[key] = formattedMinDate;
    this.updateButtonData();
  }

  selectLayeout(layout) {
    // this.button.button_picker = { //   ...this.button.button_picker,  //   style: layout.key,   // };
    this.datepickerForm.patchValue({ style: layout.key });
    this.onChange();
    // this.updateButtonData();
  }

  updateTimeFromString(timeString: string): Date | null {
    if (!timeString) {
      return null; // Return null if the input is invalid
    }

    const currentDate = new Date(); // Get the current date

    // Check if the time string is in 12-hour format with AM/PM
    const timeRegex12Hour = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
    const timeRegex24Hour = /^(\d{1,2}):(\d{2})$/;

    let hours: number;
    let minutes: number;

    if (timeRegex12Hour.test(timeString)) {
      // Parse 12-hour format (e.g., "03:00 PM")
      const match = timeString.match(timeRegex12Hour);
      if (match) {
        hours = parseInt(match[1], 10);
        minutes = parseInt(match[2], 10);
        const isPM = match[3].toUpperCase() === "PM";

        // Convert to 24-hour format
        if (isPM && hours < 12) {
          hours += 12;
        } else if (!isPM && hours === 12) {
          hours = 0; // Handle 12 AM case
        }
      }
    } else if (timeRegex24Hour.test(timeString)) {
      // Parse 24-hour format (e.g., "15:25")
      const match = timeString.match(timeRegex24Hour);
      if (match) {
        hours = parseInt(match[1], 10);
        minutes = parseInt(match[2], 10);
      }
    } else {
      console.error("Invalid time format:", timeString);
      return null; // Return null if the format is invalid
    }

    // Update the time
    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(0); // Optional: Reset seconds to 0
    currentDate.setMilliseconds(0); // Optional: Reset milliseconds to 0

    return currentDate;
  }



  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }
}
